import Service from '../../services';

const state = {
    data_page: [],
    path_url: '',
};

const getters = {

};

const actions = {
    setPathUrl({commit}, url) {
        commit('SET_PATH_URL', url)
    },
    getDataPage({commit},data) {
        return Service.page.getDataPage(data).then(res => {
            commit('SET_PAGE_DATA', res)
        }).catch(error => {
            console.log(error);
        })
    }
};

const mutations = {
    SET_PATH_URL(state, url) {
        state.path_url = url;
    },
    SET_PAGE_DATA(state, data) {
        state.data_page = data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
